import {Injectable} from "@angular/core";
import {DefaultPersistenceResultHandler, EntityAction} from "@ngrx/data";
import {Action} from "@ngrx/store";

@Injectable({ providedIn: 'root' })
export class PagePersistenceResultHandler extends DefaultPersistenceResultHandler {
    handleSuccess(originalAction: EntityAction): (data: any) => Action {
        // // console.logByType['actionHandler', originalAction]);
        const actionHandler = super.handleSuccess(originalAction);
        return (data: any) => {
            const action = actionHandler(data);
            if (action && data && data.page) {
                const page = data.page;
                (action as any).payload.page = page;
                // (action as any).payload.currentPageItemIndexes$ = data.currentPageItemIndexes$;
                // (action as any).payload.correlationId = [];
                // (action as any).payload.pages .push[page];
            }
            return action;
        };

    }

}